import React from "react";

const CommitmentSection = () => {
  return (
    <section
      id="commitment"
      className="py-16 px-6 sm:px-12 lg:px-24 text-gray-800"
    >
      {/* Introductory Text Section */}
      <div className="text-center mb-12">
        <h2 className="text-4xl font-extrabold mb-6 text-primary lg:text-5xl sm:text-3xl">
          Welcome to Your Trusted Real Estate Partner
        </h2>
        <p className="text-base leading-relaxed max-w-3xl mx-auto text-gray-600 sm:text-lg lg:text-xl">
          Real estate isn’t just about buying or selling properties; it’s about
          finding homes, creating investments, and building futures. At
          <strong className="text-primary"> Advaitha Realtors</strong>, we are
          redefining the real estate experience, offering you expertise,
          transparency, and a commitment to delivering excellence.
        </p>
        <p className="text-base leading-relaxed max-w-3xl mx-auto text-gray-600 mt-4 sm:text-lg lg:text-xl">
          As we head into 2025, the Bangalore real estate market offers
          opportunities for investors and homebuyers alike. Whether you’re
          looking for affordable housing, high-end properties, or commercial
          real estate, Bangalore’s diverse market caters to all needs. The key
          is to stay ahead of these trends, choose your investments wisely, and
          consult with a trusted real estate advisor to ensure that you make
          informed, profitable decisions.
        </p>
      </div>
      {/* Subheading: Our Commitment */}
      <h3 className="text-3xl font-bold text-center mb-6 text-gray-800 sm:text-4xl lg:text-5xl">
        Our Commitment to You
      </h3>

      {/* Commitment Description */}
      <p className="text-base leading-relaxed text-center max-w-3xl mx-auto text-gray-600 sm:text-lg lg:text-xl mb-8">
        We believe that a home is more than just a structure; it’s a space where
        peace and happiness flourish. With years of expertise in real estate and
        an unwavering focus on customer satisfaction, we ensure that every
        project we deliver exceeds your expectations.
      </p>
      {/* Main Heading */}
      <h2 className="text-2xl font-extrabold text-center text-primary mb-8 sm:text-3xl lg:text-4xl">
        Let us guide you on your journey to finding the perfect residence.
      </h2>

      {/* Final Call to Action */}
      <p className="text-lg font-semibold text-center text-primary sm:text-xl lg:text-2xl mb-4">
        Take the First Step Towards Your Dream Home
      </p>

      {/* Call to Action */}
      <p className="text-base text-center max-w-3xl mx-auto text-gray-600 sm:text-lg lg:text-xl">
        Contact us today to schedule a site visit or learn more.
      </p>
    </section>
  );
};

export default CommitmentSection;
